import { DatePicker, Modal } from 'antd';
import React from 'react';
import * as Yup from "yup";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { BASE_URLS } from "../../../core/data/redux/apis/urls";
import Api from "../../../core/data/redux/utils/apiCall";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import dayjs from 'dayjs';

interface SyncNocRequestProps {
    nocType?: string;
    empId?: string;
    onSyncSuccess?: () => void;
}

// const schema = Yup.object().shape({
//     start_date: Yup.string().test(
//         "start_date-required",
//         "Start date is required",
//         function (value) {
//             const { empId } = this.options.context || {};
//             return empId ? true : !!value; // validate only if no empId
//         }
//     ),

//     end_date: Yup.string().test(
//         "end_date-required",
//         "End date is required",
//         function (value) {
//             const { empId } = this.options.context || {};
//             return empId ? true : !!value;
//         }
//     ),
// });

const SyncNocRequest = (props: SyncNocRequestProps) => {

    const { nocType, empId } = props;
    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(false);

    const userJson = React.useMemo(() => {
        try {
            const u = localStorage.getItem("user");
            return u && u !== "undefined" ? JSON.parse(u) : {};
        } catch {
            return {};
        }
    }, []);

    const effectiveEmpId = empId || userJson?.empId || userJson?.emp_id;

    const { control, handleSubmit } = useForm({
        defaultValues: {
            start_date: null,
            end_date: null,
        },
    });

    const handeOpen = async (key: any) => {
        if (effectiveEmpId) {
            try {
                const payload = {
                    empId: effectiveEmpId,
                    requestType: nocType
                };
                setIsLoading(true);
                const endPoint = `${BASE_URLS.BASE_URL}noc-common/sync-emp-noc-requests`;
                await Api.post(`${endPoint}`, payload);
                setIsLoading(false);
                toast.success("Noc Synced proceeded Successfully");
                if (props.onSyncSuccess) {
                    props.onSyncSuccess();
                }
                return;
            } catch (error: any) {
                console.log('error', error)
                setIsLoading(false);
                toast.error("Noc Sync Failed");
                return;
            }
        } else {
            setIsModalOpen(true);
        }

    };
    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const onSubmit = async (data: any) => {
        try {
            const payload = {
                fromDate: data.start_date,
                toDate: data.end_date,
                requestType: nocType
            };
            setIsLoading(true);
            const endPoint = `${BASE_URLS.BASE_URL}noc-common/sync-noc-requests`;
            await Api.post(`${endPoint}`, payload);
            setIsLoading(false);
            setIsModalOpen(false);
            toast.success("Noc Synced proceeded Successfully");
            if (props.onSyncSuccess) {
                props.onSyncSuccess();
            }
            return;
        } catch (error: any) {
            setIsLoading(false);
            toast.error("Noc Sync Failed");
            return;
        }
    }

    const formattedNocTitle = nocType
        ? nocType.replace(/_/g, " ").replace(/-/g, " ")
        : "NOC";

    return (
        <>
            <button
                className="btn btn-outline-primary text-nowrap"
                type="button"
                onClick={handeOpen}
                disabled={isLoading}
            >
                {isLoading ? (
                    <div className="spinner-border spinner-border-sm me-1" role="status"></div>
                ) : (
                    <i className="ti ti-refresh me-1"></i>
                )}
                {`Sync ${formattedNocTitle}`}
            </button>
            <Modal
                title={`Sync ${formattedNocTitle} Request`}
                open={isModalOpen}
                onCancel={handleCancel}
                footer={null}
            >
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="row mt-5">
                        <div className="col-md-6">
                            <label className="form-label">Sync From</label>
                            <Controller
                                name="start_date"
                                control={control}
                                rules={{ required: "Start date is required" }}
                                render={({ field, fieldState: { error } }) => (
                                    <div>
                                        <DatePicker
                                            {...field}
                                            format="DD/MM/YYYY"
                                            className="form-control"
                                            style={{ width: "100%" }}
                                            placeholder="Select date"
                                            value={field.value ? dayjs(field.value) : null} // Convert to dayjs for AntD
                                            onChange={(date) => field.onChange(date ? date.toISOString() : null)} // store ISO date
                                        />
                                        {error && (
                                            <small style={{ color: "red" }}>{error.message}</small>
                                        )}
                                    </div>
                                )}
                            />
                        </div>
                        <div className="col-md-6">
                            <label className="form-label">Sync To</label>
                            <Controller
                                name="end_date"
                                control={control}
                                rules={{ required: "End date is required" }}
                                render={({ field, fieldState: { error } }) => (
                                    <div>
                                        <DatePicker
                                            {...field}
                                            format="DD/MM/YYYY"
                                            className="form-control"
                                            style={{ width: "100%" }}
                                            placeholder="Select date"
                                            value={field.value ? dayjs(field.value) : null} // Convert to dayjs for AntD
                                            onChange={(date) => field.onChange(date ? date.toISOString() : null)} // store ISO date
                                        />
                                        {error && (
                                            <small style={{ color: "red" }}>{error.message}</small>
                                        )}
                                    </div>
                                )}
                            />

                        </div>
                    </div>
                    <div className="row mt-5">
                        <button
                            className="btn btn-primary" disabled={isLoading}>
                            {isLoading && <div className="spinner-border spinner-border-sm" role="status"></div>}
                            {` Sync ${nocType?.replace(/_/g, " ")} Request`}
                        </button>
                    </div>
                </form>
            </Modal>
        </>
    );
}

export default SyncNocRequest;
